"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTheme = _interopRequireDefault(require("@material-ui/styles/useTheme"));

var _reactMasonryCss = _interopRequireDefault(require("react-masonry-css"));

var _ReactOverlay = _interopRequireDefault(require("@micado-digital/react-overlay/ReactOverlay"));

var _Item = _interopRequireDefault(require("./Item"));

var _Skeleton = _interopRequireDefault(require("./Skeleton"));

var _ReactGallery = _interopRequireDefault(require("./ReactGallery03.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ReactGallery03 = function ReactGallery03(_ref) {
  var _elements$slice;

  var _ref$absoluteMediaURL = _ref.absoluteMediaURLs,
      absoluteMediaURLs = _ref$absoluteMediaURL === void 0 ? false : _ref$absoluteMediaURL,
      _ref$buttonLabel = _ref.buttonLabel,
      buttonLabel = _ref$buttonLabel === void 0 ? "Mehr anzeigen" : _ref$buttonLabel,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? "medium" : _ref$buttonSize,
      _ref$buttonVariant = _ref.buttonVariant,
      buttonVariant = _ref$buttonVariant === void 0 ? "contained" : _ref$buttonVariant,
      breakpoints = _ref.breakpoints,
      elements = _ref.elements,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang,
      mediaFormats = _ref.mediaFormats,
      overlayMediaFormats = _ref.overlayMediaFormats,
      resourceURL = _ref.resourceURL,
      _ref$showMoreItems = _ref.showMoreItems,
      showMoreItems = _ref$showMoreItems === void 0 ? false : _ref$showMoreItems,
      skeleton = _ref.skeleton,
      _ref$skeletonItems = _ref.skeletonItems,
      skeletonItems = _ref$skeletonItems === void 0 ? 9 : _ref$skeletonItems,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 30 : _ref$spacing,
      _ref$visibleItems = _ref.visibleItems,
      visibleItems = _ref$visibleItems === void 0 ? 6 : _ref$visibleItems,
      _ref$webpFallback = _ref.webpFallback,
      webpFallback = _ref$webpFallback === void 0 ? true : _ref$webpFallback;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      mediaID = _useState2[0],
      setMediaID = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      totalItemsCount = _useState4[0],
      setTotalItemsCount = _useState4[1];

  var _useState5 = (0, _react.useState)(visibleItems),
      _useState6 = _slicedToArray(_useState5, 2),
      numberOfItemsShown = _useState6[0],
      setNumberOfItemsShown = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      showButton = _useState8[0],
      setShowButton = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = _slicedToArray(_useState9, 2),
      masonryBreakpoints = _useState10[0],
      setMasonryBreakpoints = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      open = _useState12[0],
      setOpen = _useState12[1];

  var theme = (0, _useTheme.default)();
  var css = (0, _ReactGallery.default)(spacing);
  (0, _react.useEffect)(function () {
    if (elements && elements.length > 0) {
      setTotalItemsCount(elements.length);
    }
  }, [elements.length]);
  (0, _react.useEffect)(function () {
    if (!showMoreItems) {
      setNumberOfItemsShown(totalItemsCount !== null && totalItemsCount !== void 0 ? totalItemsCount : elements.length);
    }

    if (numberOfItemsShown === totalItemsCount) {
      setShowButton(false);
    }
  }, [numberOfItemsShown, showMoreItems, setShowButton, totalItemsCount]);
  (0, _react.useEffect)(function () {
    var _theme$breakpoints;

    if (!breakpoints) return;
    var values = theme === null || theme === void 0 ? void 0 : (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.values;
    var _masonryBreakpoints = {};
    var highest = 0;

    if (breakpoints.xs) {
      _masonryBreakpoints[values.sm] = breakpoints.xs;
      highest = breakpoints.xs;
    }

    if (breakpoints.sm) {
      _masonryBreakpoints[values.md] = breakpoints.sm;
      highest = breakpoints.sm;
    }

    if (breakpoints.md) {
      _masonryBreakpoints[values.lg] = breakpoints.md;
      highest = breakpoints.md;
    }

    if (breakpoints.lg) {
      _masonryBreakpoints[values.xl] = breakpoints.lg;
      highest = breakpoints.lg;
    }

    if (breakpoints.xl) {
      highest = breakpoints.xl;
    }

    _masonryBreakpoints.default = highest;
    setMasonryBreakpoints(_masonryBreakpoints);
  }, []);

  if (skeleton) {
    return /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
      breakPoints: masonryBreakpoints,
      css: css,
      skeletonItems: skeletonItems
    });
  }

  if (!(mediaFormats !== null && mediaFormats !== void 0 && mediaFormats.xs)) return null;

  var handleClick = function handleClick(id) {
    setMediaID(id);
    setOpen(true);
  };

  var showMore = function showMore() {
    if (showMoreItems) {
      if (numberOfItemsShown + visibleItems <= totalItemsCount) {
        setNumberOfItemsShown(numberOfItemsShown + visibleItems);
      } else {
        setNumberOfItemsShown(totalItemsCount);
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-03", css.root)
  }, /*#__PURE__*/_react.default.createElement(_reactMasonryCss.default, {
    breakpointCols: masonryBreakpoints,
    className: "mco-gallery-03__grid",
    columnClassName: "mco-gallery-03__column"
  }, (_elements$slice = elements.slice(0, numberOfItemsShown)) === null || _elements$slice === void 0 ? void 0 : _elements$slice.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_Item.default, {
      key: item.id,
      absoluteMediaURLs: absoluteMediaURLs,
      data: item,
      id: index,
      lang: lang,
      mediaFormats: mediaFormats,
      resourceURL: resourceURL,
      webpFallback: webpFallback,
      onClick: handleClick
    });
  })), showButton && showMoreItems && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: css.button,
    color: "primary",
    onClick: showMore,
    size: buttonSize,
    variant: buttonVariant
  }, buttonLabel), open && /*#__PURE__*/_react.default.createElement(_ReactOverlay.default, {
    absoluteMediaURLs: absoluteMediaURLs,
    images: elements,
    imagesPos: mediaID,
    mediaFormats: overlayMediaFormats,
    mode: "images",
    resourceURL: resourceURL,
    setOpen: setOpen
  }));
};

ReactGallery03.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  buttonLabel: _propTypes.default.string,
  buttonSize: _propTypes.default.string,
  buttonVariant: _propTypes.default.string,
  breakpoints: _propTypes.default.object,
  elements: _propTypes.default.array,
  mediaFormats: _propTypes.default.object,
  overlayMediaFormats: _propTypes.default.object,
  resourceURL: _propTypes.default.string,
  showMoreItems: _propTypes.default.bool,
  skeleton: _propTypes.default.bool,
  skeletonItems: _propTypes.default.number,
  spacing: _propTypes.default.number,
  visibleItems: _propTypes.default.number,
  webpFallback: _propTypes.default.bool
};
var _default = ReactGallery03;
exports.default = _default;